export const BRAND = {
  name: "BIOSYN",
  descriptor: "ADVANCED AQUACULTURE SOLUTIONS",
  tagline: "ADVANCED PRODUCTS. SMARTER POND MANAGEMENT. BETTER AQUACULTURE.",
  phone: "89859 30908",
  phoneIntl: "918985930908",
  email: "sales@bbiosyn.com",
  address: "Auto Nagar, Belagavi (Belgaum), Karnataka – 590015, India",
  mapsQuery: "Auto Nagar, Belagavi, Karnataka 590015 India",
  logo: "https://customer-assets-v7afamib.emergentagent.net/job_pond-management-hub-1/artifacts/1rr0bl8r_Final%20Logo%20-%20Biosyn.png",
  logoWhite: "https://customer-assets-v7afamib.emergentagent.net/job_pond-management-hub-1/artifacts/1rr0bl8r_Final%20Logo%20-%20Biosyn.png",
};

export const IMAGES = {
  heroPond: "https://images.pexels.com/photos/14024725/pexels-photo-14024725.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  aeration: "https://images.pexels.com/photos/14024728/pexels-photo-14024728.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  shrimpHarvest: "https://images.pexels.com/photos/32230044/pexels-photo-32230044.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  shrimpClose: "https://images.pexels.com/photos/5273798/pexels-photo-5273798.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  fishWater: "https://images.unsplash.com/photo-1781290557047-dab72478afca?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  aerialPonds: "https://images.unsplash.com/photo-1769407515629-587a7ffc3542?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  lab: "https://images.pexels.com/photos/8533045/pexels-photo-8533045.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  microscope: "https://images.pexels.com/photos/8770719/pexels-photo-8770719.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  placeholder: "https://customer-assets-v7afamib.emergentagent.net/job_pond-management-hub-1/artifacts/1rr0bl8r_Final%20Logo%20-%20Biosyn.png",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Products", to: "/products" },
  { label: "Our Approach", to: "/our-approach" },
  { label: "Technical Services", to: "/technical-services" },
  { label: "BIOSYN Aqua Lab", to: "/aqua-lab" },
  { label: "Career", to: "/aqua-lab#careers" },
  { label: "Contact", to: "/contact" },
];

export const FARM_TYPES = [
  "Shrimp Farm",
  "Fish Farm",
  "Hatchery",
  "Dealer / Distributor",
  "Aquaculture Professional",
  "Other",
];

export const SPECIES = [
  "Vannamei",
  "Black Tiger Shrimp",
  "Freshwater Fish",
  "Tilapia",
  "Other",
];
